import React from 'react';
import { ActionIcon, Text, Title } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import AlertBadge from './AlertBadge';
import Loader from './Loader';

type Props = {
    title: string;
    timeFrame?: string;
    alert?: {
        icon?: React.ReactNode;
        message: string;
    };
    children: React.ReactNode;
    isLoading?: boolean;
    reload?: () => void;
    wrapperClassName?: string;
};

function OverviewCard({
    title,
    timeFrame,
    alert,
    children,
    isLoading = false,
    reload,
    wrapperClassName,
}: Props) {
    return (
        <div
            className={`h-56 flex flex-col flex-1 bg-white p-5 gap-4 shadow-md rounded-xl transition-[box-shadow] duration-300 ${
                wrapperClassName ?? ''
            }`.trim()}
        >
            <div className="gap-1">
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <Title order={3}>{title}</Title>
                        {alert && (
                            <AlertBadge
                                icon={alert.icon}
                                alert={alert.message}
                            />
                        )}
                    </div>
                    {reload && (
                        <ActionIcon
                            variant="subtle"
                            className="text-primary rounded-md p-1 w-min h-min"
                            onClick={reload}
                        >
                            <IconRefresh />
                        </ActionIcon>
                    )}
                </div>
                {timeFrame && (
                    <Text className="text-xs text-gray-400">{timeFrame}</Text>
                )}
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="flex flex-1 items-center justify-center max-h-full overflow-hidden">
                    {children}
                </div>
            )}
        </div>
    );
}

export default OverviewCard;
